// Previously known as common/api

import fetch from 'isomorphic-fetch'
import qs from 'qs'

const headers = {
  'Content-Type': 'application/json'
}

const getJSON = async (res) => {
  if (res.status >= 200 && res.status < 300) {
    const data = await res.json()
    return data
  }

  const err = new Error(res.responseText)

  if (res.status >= 400 && res.status < 500) {
    const data = await res.json()
    err.data = data
  }

  throw err
}

export const get = (url, query = {}) => {
  const queryString = qs.stringify(query)

  return fetch(`${url}?${queryString}`, { headers }).then(getJSON)
}
